import { useState, useEffect } from 'react';
import { Quiz } from './components/Quiz/Quiz';
import { Results } from './components/Results/Results';
import { FinalScreen } from './components/FinalScreen/FinalScreen';

import S from './Main.styled';

export const Main = () => {
  const [summary, setSummary] = useState('');
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [sessionKey, setSessionKey] = useState<string>('');

  const onSaveSummary = (summary: string) => {
    setSummary(summary);
  };

  const generateRandomString = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const length = 16;
    let result = '';
  
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
  
    return result;
  }

  useEffect(() => {
    if (sessionKey === '') {
      const key = generateRandomString();
      setSessionKey(key);
    }
  }, []);

  const sentToEmailCallback = () => {
    setIsEmailSent(true);
  };

  const renderComponent = () => {
    if (isEmailSent) {
      return <FinalScreen />;
    } else if (summary) {
      return (
        <Results summary={summary} sentToEmailCallback={sentToEmailCallback} sessionKey={sessionKey}/>
      );
    }
    return <Quiz onSaveSummary={onSaveSummary} sessionKey={sessionKey}/>;
  };

  return <S.Wrapper>{renderComponent()}</S.Wrapper>;
};
